<div class="form">
    <h1>NOW-regeling <div style="color:#ee7201; display: inline;">tool</div></h1>

    <div class="radio">
        <p>
            Heeft u een omzetdaling sinds 1 maart 2020?
        </p>
        <div class="options">
            <label>
                <input type="radio" name="radio1" id="radio1-opt1" value="true" [formControl]="hasdrop">
                Ja
            </label>
    
            <label>
                <input type="radio" name="radio1" id="radio1-opt2" value="false" [formControl]="hasdrop" checked>
                Nee
            </label>
        </div>
    </div>


    <div class="true-card" [@isVisible]="inputCard">

        <div class="input">
            <label for="in1">
                Wat was uw oude omzet (vóór 1 maart 2020)?
            </label>
            <div><i>€</i><input id="in1" type="number" [formControl]="oldRevenue" value="0"></div>
        </div>
        

        <div class="input">
            <label for="in2">
                Wat is uw huidige omzet?
            </label>
            <div><i>€</i><input id="in2" type="number" [formControl]="newRevenue" value="0"></div>
        </div>
        

        <div class="input">
            <label for="in3">
                Wat zijn uw maandelijkse loonkosten?
            </label>
            <div><i>€</i><input id="in3" type="number" [formControl]="labourCosts" value="0"></div>
        </div>
    </div>
    <div class="results" [@isVisible]="trueCard">
        <div>
            <p>Dit is uw omzetdaling in procenten:</p>
            <p>{{ formatNumber(revenueDrop.toFixed(2)) }} %</p>
        </div>
        <div>
            <p>Deze vergoeding kunt u onder de NOW ontvangen:</p>
            <p>€ {{ formatNumber(compensation.toFixed(2)) }}</p>
        </div>
        <div>
            <p>Dit bedrag ontvangt u als voorschot:</p>
            <p>€ {{ formatNumber(deposit.toFixed(2)) }}</p>
        </div>
    </div>
    <div class="false-card" [@isVisible]="falseCard">
        U komt niet in aanmerking voor een uitkering op basis van de NOW-regeling.
    </div>
</div>